import { z } from 'zod';

import { ProfileTemplateScopeTypeSchema } from './shared.schemas.js';

export const UpdateProfileTemplateBodySchema = z
  .object({
    name: z.string().trim().min(1).max(120).optional(),
    description: z.string().trim().max(500).nullable().optional(),
    active: z.boolean().optional(),
    permissionSlugs: z.array(z.string().trim().min(1)).min(1).optional(),
    slug: z.string().optional(),
    scopeType: ProfileTemplateScopeTypeSchema.optional(),
  })
  .refine((body) => Object.keys(body).length > 0, {
    message: 'At least one field is required',
  });

export type UpdateProfileTemplateBody = z.infer<typeof UpdateProfileTemplateBodySchema>;

export const UpdateProfileTemplateResponseSchema = z.object({
  id: z.uuid(),
});

export type UpdateProfileTemplateResponse = z.infer<typeof UpdateProfileTemplateResponseSchema>;
